import { Badge } from './ui/badge';

export function TariffCheckboxList({ tariffs, selected, onChange }) {
  var activeTariffs = tariffs.filter(function(t) { return t.is_active; });

  function toggle(tariffId) {
    var current = selected || [];
    var isChecked = current.includes(tariffId);
    var updated = isChecked
      ? current.filter(function(id) { return id !== tariffId; })
      : current.concat([tariffId]);
    onChange(updated);
  }

  if (activeTariffs.length === 0) {
    return <p className="text-xs text-slate-400 text-center py-2">No active tariffs available</p>;
  }

  return (
    <div className="max-h-40 overflow-y-auto border rounded-lg p-2 space-y-1" data-testid="applicable-tariffs-list">
      {activeTariffs.map(function(t) {
        var isChecked = (selected || []).includes(t.id);
        return (
          <label key={t.id} className={'flex items-center gap-2 px-2 py-1.5 rounded cursor-pointer text-sm hover:bg-slate-50 ' + (isChecked ? 'bg-primary/5' : '')} data-testid={'plan-tariff-' + t.id}>
            <input type="checkbox" checked={isChecked} onChange={function() { toggle(t.id); }} className="rounded border-slate-300 text-primary focus:ring-primary" />
            <span className="font-mono text-xs text-slate-600">{t.tariff_code}</span>
            <span className="text-slate-700">{t.tariff_name}</span>
            {t.state && <Badge variant="outline" className="ml-auto text-xs">{t.state}</Badge>}
          </label>
        );
      })}
    </div>
  );
}
